// // // import { voices, sectionMeta } from "../data/Knowledge";
// // // import KnowledgeSection from "../KnowledgeCenter/KnowledgeSection";

// // // /* AssochamVoice.jsx
// // //    Listing page for Assocham's advocacy voice & policy memoranda.
// // //    Image banner + title hero; clickable banner cards open the
// // //    detail overview + download page (handled by the parent router). */
// // // export default function AssochamVoice({ onOpen }) {
// // //   return (
// // //     <KnowledgeSection
// // //       section={sectionMeta.voices}
// // //       items={voices}
// // //       onOpen={onOpen}
// // //     />
// // //   );
// // // }




// // // new code 




// // import { useNavigate } from "react-router-dom";
// // import { voices, sectionMeta } from "../data/Knowledge";
// // import KnowledgeSection from "../KnowledgeCenter/KnowledgeSection";

// // export default function AssochamVoice() {
// //   const navigate = useNavigate();

// //   return (
// //     <KnowledgeSection
// //       section={sectionMeta.voices}
// //       items={voices}
// //       onOpen={(item) => navigate(`/knowledge/assocham-voice/${item.id}`)}
// //     />
// //   );
// // }




// // new new code 




// // import { useEffect, useState } from "react";
// // import { useNavigate } from "react-router-dom";
// // import { sectionMeta } from "../data/Knowledge";
// // import KnowledgeSection from "../KnowledgeCenter/KnowledgeSection";

// // const VOICE_API_URL = "https://www.assocham.org/api/voice-full.php";

// // function useFetchList(url) {
// //   const [items, setItems] = useState([]);
// //   const [loading, setLoading] = useState(true);
// //   const [error, setError] = useState(null);

// //   useEffect(() => {
// //     let cancelled = false;

// //     fetch(url)
// //       .then((res) => {
// //         if (!res.ok) throw new Error("Network response was not ok");
// //         return res.json();
// //       })
// //       .then((json) => {
// //         if (cancelled) return;
// //         if (json.success) {
// //           setItems(json.data);
// //         } else {
// //           setError(json.message || "Failed to load data");
// //         }
// //       })
// //       .catch(() => {
// //         if (!cancelled) setError("Failed to load data");
// //       })
// //       .finally(() => {
// //         if (!cancelled) setLoading(false);
// //       });

// //     return () => {
// //       cancelled = true;
// //     };
// //   }, [url]);

// //   return { items, loading, error };
// // }

// // export default function AssochamVoice() {
// //   const navigate = useNavigate();
// //   const { items: voices, loading, error } = useFetchList(VOICE_API_URL);

// //   if (loading) return <div className="py-24 text-center text-mute">Loading...</div>;
// //   if (error) return <div className="py-24 text-center text-red-600">{error}</div>;

// //   return (
// //     <KnowledgeSection
// //       section={sectionMeta.voices}
// //       items={voices}
// //       onOpen={(item) => navigate(`/knowledge/assocham-voice/${item.id}`)}
// //     />
// //   );
// // }




// // new code 



// import { useEffect, useState } from "react";

// import { useNavigate } from "react-router-dom";

// import { sectionMeta } from "../data/Knowledge";

// import KnowledgeSection from "../KnowledgeCenter/KnowledgeSection";

  

// const VOICE_API_URL = "https://www.assocham.org/api/voice-full.php";

// const TARGET_YEAR = 2026;

  

// // Extract the year from a date value (handles Date, timestamp, and date strings)
// function getYear(value) {
//   if (!value) return null;
//   const date = value instanceof Date ? value : new Date(value);
//   if (isNaN(date.getTime())) return null;
//   return date.getFullYear();
// }

  

// function useFetchList(url) {
//   const [items, setItems] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);

//   useEffect(() => {
//     let cancelled = false;

//     fetch(url)
//       .then((res) => {
//         if (!res.ok) throw new Error("Network response was not ok");
//         return res.json();
//       })
//       .then((json) => {
//         if (cancelled) return;
//         if (json.success) {
//           setItems(Array.isArray(json.data) ? json.data : []);
//         } else {
//           setError(json.message || "Failed to load data");
//         }
//       })
//       .catch(() => {
//         if (!cancelled) setError("Failed to load data");
//       })
//       .finally(() => {
//         if (!cancelled) setLoading(false);
//       });

//     return () => {
//       cancelled = true;
//     };
//   }, [url]);

//   return { items, loading, error };
// }

  

// export default function AssochamVoice() {
//   const navigate = useNavigate();
//   const { items: voices, loading, error } = useFetchList(VOICE_API_URL);

//   // Frontend filter:
//   // 1) Title must contain "Voice" (e.g. "ASSOCHAM VOICE") (case-insensitive)
//   // 2) Year must be 2026
//   //    - First try the date field on the item
//   //    - If no valid date, fall back to the year embedded in the title (e.g. "Vol. June 2026")
//   const filteredVoices = voices.filter((item) => {
//     const title = (item?.title || item?.name || "").toLowerCase();
//     const matchesTitle = title.includes("voice");

//     // Year from a real date field (if present)
//     const dateField =
//       item?.date || item?.publishDate || item?.published_on || item?.created_at || item?.pub_date;
//     let year = getYear(dateField);

//     // Fallback: find a 4-digit year in the title
//     if (year === null) {
//       const match = title.match(/20\d{2}/);
//       year = match ? parseInt(match[0], 10) : null;
//     }

//     return matchesTitle && year === TARGET_YEAR;
//   });

//   if (loading) return <div className="py-24 text-center text-mute">Loading...</div>;
//   if (error) return <div className="py-24 text-center text-red-600">{error}</div>;

//   return (
//     <KnowledgeSection
//       section={sectionMeta.voices}
//       items={filteredVoices}
//       onOpen={(item) => navigate(`/knowledge/assocham-voice/${item.id}`)}
//     />
//   );
// }







// new code 




import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { sectionMeta } from "../data/Knowledge";
import KnowledgeSection from "../KnowledgeCenter/KnowledgeSection";

const VOICE_API_URL = "https://www.assocham.org/assocham_backend/api/voice-full.php";
const SITE_BASE = "https://www.assocham.org/assocham_backend"; // TODO: your site base URL

const TARGET_YEAR = 2026;

// Extract the year from a date value (handles Date, timestamp, and date strings)
function getYear(value) {
  if (!value) return null;
  const date = value instanceof Date ? value : new Date(value);
  if (isNaN(date.getTime())) return null;
  return date.getFullYear();
}

function useFetchList(url) {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;

    fetch(url)
      .then((res) => {
        if (!res.ok) throw new Error("Network response was not ok");
        return res.json();
      })
      .then((json) => {
        if (cancelled) return;
        if (json.success) {
          setItems(Array.isArray(json.data) ? json.data : []);
        } else {
          setError(json.message || "Failed to load data");
        }
      })
      .catch(() => {
        if (!cancelled) setError("Failed to load data");
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, [url]);

  return { items, loading, error };
}

export default function AssochamVoice() {
  const navigate = useNavigate();
  const { items: voices, loading, error } = useFetchList(VOICE_API_URL);

  // The API returns a RELATIVE path like "uploads/files/xxx.pdf".
  // Make it absolute so the PDF opens from any domain.
  const absoluteUrl = (link) => {
    if (!link) return "";
    if (/^https?:\/\//i.test(link) || link.startsWith("//")) return link;
    return SITE_BASE + "/" + link.replace(/^\/+/, "");
  };

  // Frontend filter:
  // 1) Title must contain "Voice" (e.g. "ASSOCHAM VOICE") (case-insensitive)
  // 2) Year must be 2026
  //    - First try the date field on the item
  //    - If no valid date, fall back to the year embedded in the title (e.g. "Vol. June 2026")
  const filteredVoices = voices.filter((item) => {
    const title = (item?.title || item?.name || "").toLowerCase();
    const matchesTitle = title.includes("voice");

    // Year from a real date field (if present)
    const dateField =
      item?.date || item?.publishDate || item?.published_on || item?.created_at || item?.pub_date;
    let year = getYear(dateField);

    // Fallback: find a 4-digit year in the title
    if (year === null) {
      const match = title.match(/20\d{2}/);
      year = match ? parseInt(match[0], 10) : null;
    }

    return matchesTitle && year === TARGET_YEAR;
  });

  // ★ KEY FIX: convert the RELATIVE link to an ABSOLUTE URL BEFORE the items
  //   reach BannerCard. BannerCard renders the banner area as
  //   <a href={item.link} target="_blank"> — with a relative link the browser
  //   resolves it against the app origin (e.g. localhost:3000/uploads/...).
  //   With an absolute link, banner click + View click both open the PDF
  //   from https://www.assocham.org.
  const processedVoices = filteredVoices.map((item) => ({
    ...item,
    link: absoluteUrl(item?.link),
  }));

  // Card click -> PDF opens DIRECTLY (same as the PHP site's target="_blank").
  // No detail page, no member check.
  const handleOpen = (item) => {
    const url = item?.link; // already absolute
    if (url) {
      window.open(url, "_blank", "noopener,noreferrer");
      return;
    }
    // Fallback: no PDF link -> go to the detail route using slug (API has no "id")
    const id = item?.slug ?? item?.id;
    if (id) navigate(`/knowledge/assocham-voice/${id}`);
  };

  if (loading) return <div className="py-24 text-center text-mute">Loading...</div>;
  if (error) return <div className="py-24 text-center text-red-600">{error}</div>;

  return (
    <KnowledgeSection
      section={sectionMeta.voices}
      items={processedVoices}
      onOpen={handleOpen}
    />
  );
}
